import { Button, IconArrowLeft, IconArrowRight } from 'uikit';

import type { IHeaderParams } from 'ag-grid-community';
import React, { useCallback, useState } from 'react';

const Style = { display: 'flex', alignItems: 'center' };

interface IUnitCostWithOtherHeader extends IHeaderParams {
    collapseKeys: string[];
    id: number;
}

export const UnitCostWithOtherHeader = ({ collapseKeys, api, displayName, id }: IUnitCostWithOtherHeader) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    const onExpandCollapseClick = useCallback(() => {
        const collapsableColumns = collapseKeys.map((key) => `${id}${key}`);

        api.setColumnsVisible(collapsableColumns, !isExpanded);
        setIsExpanded(!isExpanded);
    }, [api, collapseKeys, id, isExpanded]);

    return (
        <div style={Style}>
            {displayName}
            <Button
                view="clear"
                iconRight={isExpanded ? IconArrowLeft : IconArrowRight}
                onlyIcon
                onClick={onExpandCollapseClick}
                size="xs"
                form="brick"
            />
        </div>
    );
};

UnitCostWithOtherHeader.displayName = 'UnitCostWithOtherHeader';
